import { ParkedAppointment } from "../hooks/useAppointmentClipboard";
import "./HeldAppointmentChip.scss";

interface HeldAppointmentChipProps {
  parked: ParkedAppointment;
  onClear: () => void;
}

export const HeldAppointmentChip = (props: HeldAppointmentChipProps) => {
  const { parked, onClear } = props;

  const isCut = parked.mode === "cut";
  const origin = isCut ? parked.originalLabel : "Copied";

  return (
    <div
      className={`held-appointment-chip held-appointment-chip--${parked.mode} d-flex align-items-center gap-2 ms-2 px-2 py-1 border rounded-pill`}
      title={origin ? `${parked.label} · ${origin}` : parked.label}
      role="status"
      aria-live="polite"
    >
      <span className="held-appointment-chip__icon">
        <i className={`fa ${isCut ? "fa-cut" : "fa-copy"}`} aria-hidden="true" />
      </span>
      <span className="held-appointment-chip__label fw-semibold text-truncate">
        {parked.label}
      </span>
      {origin && (
        <>
          <span className="text-muted flex-shrink-0">·</span>
          <span className="held-appointment-chip__origin text-muted small text-truncate">
            {origin}
          </span>
        </>
      )}
      <button
        type="button"
        className="held-appointment-chip__clear btn"
        onClick={onClear}
        title={isCut ? "Put back" : "Clear"}
        aria-label={isCut ? "Put appointment back" : "Clear copied appointment"}
      >
        <i className="fa fa-times" aria-hidden="true" />
      </button>
    </div>
  );
};

export default HeldAppointmentChip;
